module.exports = __webpack_public_path__ + "static/img/login.51d35345.png";